import React from "react";
import { flowChartElement } from "../../utils/dashboardEnum";

const IconSvg = ({ svgName }) => {
  return (
    <>
      {(svgName === flowChartElement.bill) ||(svgName === flowChartElement.invoice) ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="bill"
          width="21.548"
          height="23.488"
          viewBox="0 0 21.548 23.488"
        >
          <path
            id="Path_2479"
            data-name="Path 2479"
            d="M38.447-495.838a3.1,3.1,0,0,0-2.266,2.4c-.034.226-.049,3.168-.039,10.176l.015,9.858.1.2a1.116,1.116,0,0,0,1.231.549,17.849,17.849,0,0,0,1.766-.981c.839-.505,1.55-.917,1.584-.917s.848.476,1.824,1.054c1.766,1.054,1.77,1.054,2.06,1.054a1.512,1.512,0,0,0,.461-.074c.093-.039.907-.515,1.815-1.059a12.21,12.21,0,0,1,1.736-.961c.054.015.78.441,1.623.947,1.452.878,1.54.922,1.815.942a1.027,1.027,0,0,0,.922-.363,1.311,1.311,0,0,0,.245-.436c.039-.152.054-2.128.054-6.861v-6.645l1.461-.015,1.457-.015.28-.132a2.021,2.021,0,0,0,.937-.917l.157-.324v-5.1l-.118-.363a3.111,3.111,0,0,0-2.192-2.016c-.368-.1-.574-.1-8.475-.093C39.095-495.932,38.79-495.927,38.447-495.838ZM52.1-494.284c-.025.049-.088.211-.142.358-.1.27-.1.27-.128,9.814l-.025,9.549-1.172-.7a14.986,14.986,0,0,0-1.4-.77,2.436,2.436,0,0,0-1.064,0c-.113.034-.927.49-1.8,1.015l-1.594.956-1.437-.863c-.79-.476-1.5-.9-1.584-.951a2.166,2.166,0,0,0-.888-.245c-.476,0-.682.088-1.922.834l-1.211.731-.015-9.274c0-5.929,0-9.338.039-9.451a1.491,1.491,0,0,1,.947-.991c.24-.083.647-.088,6.846-.093C51.8-494.367,52.13-494.362,52.1-494.284Zm3.232.083a1.47,1.47,0,0,1,.677.682c.113.206.113.226.128,2.506.015,2.1,0,2.305-.069,2.388s-.177.093-1.378.093H53.4v-2.418c0-2.32,0-2.423.1-2.634a1.362,1.362,0,0,1,.829-.741A1.7,1.7,0,0,1,55.328-494.2Z"
            transform="translate(-36.139 495.933)"
            fill="#f80"
          />
          <path
            id="Path_2480"
            data-name="Path 2480"
            d="M120.929-374.931a.779.779,0,0,0,0,1.4c.211.1.245.1,3.551.088s3.34-.015,3.477-.118a1.446,1.446,0,0,0,.25-.265.789.789,0,0,0-.284-1.074c-.181-.1-.211-.1-3.511-.1A28.571,28.571,0,0,0,120.929-374.931Z"
            transform="translate(-116.351 380.931)"
            fill="#f80"
          />
          <path
            id="Path_2481"
            data-name="Path 2481"
            d="M120.917-289.67a.878.878,0,0,0-.554.623.866.866,0,0,0,.363.775l.167.113h6.778l.177-.118a.783.783,0,0,0-.054-1.324c-.167-.1-.24-.1-3.433-.113C122.309-289.719,121.029-289.7,120.917-289.67Z"
            transform="translate(-116.225 299.829)"
            fill="#f80"
          />
          <path
            id="Path_2482"
            data-name="Path 2482"
            d="M120.995-201.917a.779.779,0,0,0,.128,1.437c.123.039,1.231.049,3.477.039,3.252-.015,3.3-.015,3.433-.118a.776.776,0,0,0-.029-1.329l-.167-.113H124.5A18.341,18.341,0,0,0,120.995-201.917Z"
            transform="translate(-116.431 216.415)"
            fill="#f80"
          />
        </svg>
      ) : svgName === flowChartElement.delivery ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28.352"
          height="22.01"
          viewBox="0 0 28.352 22.01"
        >
          <g
            id="Group_15182"
            data-name="Group 15182"
            transform="translate(-329.974 -2409.105)"
          >
            <g
              id="Group_14879"
              data-name="Group 14879"
              transform="translate(-30.908 2192.105)"
            >
              <path
                id="Path_2469"
                data-name="Path 2469"
                d="M373.725,215.466l1.828-.63,1.686,1.341,4.672,2.559,2.336,1.138-1.787,1.706s-5.482,1.548-6.906,3.6-.366,10.563-.366,10.563l-9.567-5.159-.122-4.327v-4.489l.345-1.6,1.575-1.2,2.1-.871,1.808-1.422Z"
                transform="translate(4 2.619)"
                fill="#0c007b"
                opacity="0.12"
              />
            </g>
            <g id="delivery" transform="translate(329.865 2864.105)">
              <path
                id="Path_2489"
                data-name="Path 2489"
                d="M34.929-452.341c-2.664,1.462-4.9,2.719-4.968,2.8-.116.127-.127.194-.127.8v.659h-6.6l-.161.161a.6.6,0,0,0-.105.676c.15.271.155.271,3.628.271h3.24v1.994h-3.39l-.161.161a.6.6,0,0,0-.105.676c.138.249.282.271,2.022.271h1.634v2.88H27.452c-2.587,0-2.62.005-2.758.3a.477.477,0,0,0,.122.615l.188.188h4.819l.022.692c.017.6.033.7.127.8.061.055,2.282,1.3,4.929,2.753a54.315,54.315,0,0,0,5.012,2.647,52.311,52.311,0,0,0,5.012-2.647c2.653-1.457,4.868-2.692,4.929-2.753.105-.105.111-.183.111-1.606v-1.5l-.155-.133a.571.571,0,0,0-.742,0l-.155.133-.017,1.213-.017,1.207-3.86,2.121c-2.121,1.163-4.015,2.2-4.209,2.31l-.343.194.011-4.608.017-4.608,1.274-.709c.7-.388,1.29-.7,1.318-.7a8.371,8.371,0,0,1,.039,1.152,8.044,8.044,0,0,0,.061,1.324.567.567,0,0,0,.842.255,20.006,20.006,0,0,0,2.171-1.263,5.423,5.423,0,0,0,.083-1.673v-1.562l1.268-.7c.7-.382,1.285-.7,1.3-.7s.033.615.033,1.374c0,1.523.006,1.556.366,1.706a.381.381,0,0,0,.377,0c.371-.155.366-.122.366-2.293v-1.961l-.15-.15c-.089-.083-1.124-.681-2.315-1.335s-3.356-1.839-4.819-2.642C41.2-454.369,40-455,39.913-455S37.726-453.876,34.929-452.341Zm9.155.814c2.26,1.235,4.126,2.265,4.154,2.287a10.042,10.042,0,0,1-1.207.72c-1.135.615-1.263.676-1.39.615s-3.174-1.723-7.073-3.871a12.3,12.3,0,0,1-1.108-.643,27.335,27.335,0,0,1,2.443-1.357C39.941-453.782,41.824-452.768,44.084-451.527Zm-3.655,2.038c2.276,1.246,4.137,2.282,4.137,2.3a2.576,2.576,0,0,1-.432.26l-.438.238-2.625-1.446c-1.446-.792-3.318-1.822-4.159-2.282s-1.54-.853-1.54-.875a4.9,4.9,0,0,1,.892-.476C36.28-451.765,38.158-450.741,40.429-449.489Zm-4.392-.15c.991.548,2.836,1.556,4.1,2.249s2.321,1.279,2.343,1.3a26.932,26.932,0,0,1-2.564,1.446c-.039,0-8.3-4.52-8.352-4.569-.028-.022,2.509-1.4,2.592-1.407C34.2-450.625,35.045-450.181,36.036-449.639Zm-.919,3.644c2.254,1.241,4.137,2.282,4.176,2.315a46.315,46.315,0,0,1,.055,4.636l-.017,4.569-2.243-1.235c-1.235-.676-3.124-1.711-4.193-2.3l-1.955-1.069v-4.586c0-2.52.017-4.58.033-4.58S32.857-447.229,35.117-445.994Zm10.058.753v1.014l-.438.233a4.96,4.96,0,0,1-.471.238,7.728,7.728,0,0,1-.033-.986v-.986l.46-.255.471-.26C45.17-446.249,45.175-445.795,45.175-445.241Z"
                transform="translate(-21.533 0)"
                fill="#0c007b"
              />
              <path
                id="Path_2490"
                data-name="Path 2490"
                d="M41.1-273.923a.544.544,0,0,0,.543.908.711.711,0,0,0,.282-.244.465.465,0,0,0-.1-.676A.491.491,0,0,0,41.1-273.923Z"
                transform="translate(-38.566 -170.891)"
                fill="#0c007b"
              />
              <path
                id="Path_2491"
                data-name="Path 2491"
                d="M492.319-255.878a.533.533,0,0,0,.177.908.343.343,0,0,0,.393-.017.525.525,0,0,0-.216-1.014A.55.55,0,0,0,492.319-255.878Z"
                transform="translate(-464.772 -187.978)"
                fill="#0c007b"
              />
              <path
                id="Path_2492"
                data-name="Path 2492"
                d="M.385-201.922a.506.506,0,0,0-.094.842c.188.188.188.188.72.188.759,0,.975-.133.975-.582a.473.473,0,0,0-.161-.366c-.161-.155-.177-.161-.737-.161A2.053,2.053,0,0,0,.385-201.922Z"
                transform="translate(0 -238.987)"
                fill="#0c007b"
              />
            </g>
          </g>
        </svg>
      ) : svgName === flowChartElement.grn ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="Group_15126"
          data-name="Group 15126"
          width="22.688"
          height="22.696"
          viewBox="0 0 22.688 22.696"
        >
          <path
            id="Path_2469"
            data-name="Path 2469"
            d="M370.851,219.06h1.239l2.254-.2h2.376l.122,2.436.081,2.479-.081,6.089H367.42l.133-1.131-.234-7.661-.081-1.157.183-.954,1.543.1h1.888Z"
            transform="translate(-356.721 -218.377)"
            fill="#007b25"
            opacity="0.12"
          />
          <path
            id="Path_2478"
            data-name="Path 2478"
            d="M377.134,217h4.987l.7,1.334.638.635L387.572,217l1.1.638v1.734l-7.77,4.168-8.7-1.147-.928,1.392-3.646-.245-.219-3.621-.175-.547.395-.451,3.332.048h2.192Z"
            transform="translate(-366.806 -201.68)"
            fill="#007b25"
            opacity="0.12"
          />
          <g id="receiving">
            <path
              id="Path_2470"
              data-name="Path 2470"
              d="M226-505.994v6.006h10.683V-512H226Zm9.353,0v4.677H227.33v-9.353h8.023Z"
              transform="translate(-215.982 512)"
              fill="#007b25"
            />
            <path
              id="Path_2471"
              data-name="Path 2471"
              d="M286-451.335v.665h1.33V-452H286Z"
              transform="translate(-273.322 454.66)"
              fill="#007b25"
            />
            <path
              id="Path_2472"
              data-name="Path 2472"
              d="M346.031-451.8a3.8,3.8,0,0,0-.031.665v.634h2.708l-.013-.656-.013-.652-1.312-.013C346.652-451.829,346.049-451.82,346.031-451.8Z"
              transform="translate(-330.663 454.493)"
              fill="#007b25"
            />
            <path
              id="Path_2473"
              data-name="Path 2473"
              d="M286.171-391.942c-.009.031-.013.337-.009.674l.013.621.656.013.652.013V-392h-.643C286.353-392,286.189-391.987,286.171-391.942Z"
              transform="translate(-273.476 397.319)"
              fill="#007b25"
            />
            <path
              id="Path_2474"
              data-name="Path 2474"
              d="M346.171-391.817c-.009.031-.013.337-.009.674l.013.621h2.66v-1.33l-1.321-.013C346.46-391.874,346.189-391.866,346.171-391.817Z"
              transform="translate(-330.817 397.194)"
              fill="#007b25"
            />
            <path
              id="Path_2475"
              data-name="Path 2475"
              d="M286-330.335v.665h1.33V-331H286Z"
              transform="translate(-273.322 339.023)"
              fill="#007b25"
            />
            <path
              id="Path_2476"
              data-name="Path 2476"
              d="M345.913-330.348l.013.656,1.343.013,1.339.009V-331H345.9Z"
              transform="translate(-330.567 339.023)"
              fill="#007b25"
            />
            <path
              id="Path_2477"
              data-name="Path 2477"
              d="M20.107-181.837c-.12.04-.922.457-1.782.935s-1.582.851-1.6.838a.459.459,0,0,1-.071-.2,1.849,1.849,0,0,0-.479-.913,1.941,1.941,0,0,0-.811-.554l-.266-.106-2.6-.013-2.6-.013L8.56-181.2l-1.334.669H0v6.693H5.364v-1.33H7.225l1.33.665,1.33.665H14.22l3.83-2.221a32.132,32.132,0,0,0,4.074-2.478,1.968,1.968,0,0,0,.031-2.726,1.788,1.788,0,0,0-.882-.559A2.362,2.362,0,0,0,20.107-181.837Zm.9,1.339a.829.829,0,0,1,.355.585.915.915,0,0,1-.084.288c-.075.173-.222.262-3.759,2.318l-3.675,2.137H10.2l-1.33-.665-1.33-.665H5.364v-2.66H7.491l1.379-.687,1.379-.691,2.309.013c2.234.013,2.318.018,2.469.1a.675.675,0,0,1,.324.576.675.675,0,0,1-.324.576c-.146.084-.239.089-1.582.1l-1.432.013v1.334l1.609-.022c1.8-.018,1.848-.027,2.536-.359.222-.106,1.285-.683,2.371-1.285C20.665-180.671,20.674-180.675,21.011-180.5ZM3.989-177.165v1.995H1.33v-1.33H2.66v-1.33H1.33v-1.33h2.66Z"
              transform="translate(0 196.536)"
              fill="#007b25"
            />
          </g>
        </svg>
      ) : svgName === flowChartElement.payment ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="23.2"
          height="15.497"
          viewBox="0 0 23.2 15.497"
        >
          <g
            id="Group_15134"
            data-name="Group 15134"
            transform="translate(717.966 -2241.89)"
          >
            <g
              id="Group_14879"
              data-name="Group 14879"
              transform="translate(-717.069 2242.404)"
            >
              <path
                id="Path_2469"
                data-name="Path 2469"
                d="M371.692,219.026h1.33l2.419-.168h2.55l3.452.875.5,5.083v7.4s-6.252.825-10.454.9a22.313,22.313,0,0,0-3.478,0c-1.282.128-2.571.006-4.234,0a5.7,5.7,0,0,1-3.5-1.211V221.45l.934-1.923,6.8-.586,1.657.084h2.027Z"
                transform="translate(-360.277 -218.857)"
                fill="#dc1412"
                opacity="0.12"
              />
            </g>
            <path
              id="Icon_payment-cash"
              data-name="Icon payment-cash"
              d="M29.649,17.12V31.076a.994.994,0,0,1-.227.544.74.74,0,0,1-.544.227H7.219a.738.738,0,0,1-.544-.227.991.991,0,0,1-.227-.544V17.12a.993.993,0,0,1,.227-.544.742.742,0,0,1,.544-.227h21.66a.743.743,0,0,1,.544.227,1,1,0,0,1,.227.544ZM28.109,27.18V21.017a2.964,2.964,0,0,1-2.175-.906,3.017,3.017,0,0,1-.906-2.22H11.071a3.019,3.019,0,0,1-.906,2.22,2.966,2.966,0,0,1-2.175.906v6.163a2.969,2.969,0,0,1,2.175.906,3.021,3.021,0,0,1,.906,2.22H25.027a3.019,3.019,0,0,1,.906-2.22,2.968,2.968,0,0,1,2.175-.906ZM21.9,24.1a7.941,7.941,0,0,1-.227,1.722,5.807,5.807,0,0,1-.725,1.631,3.938,3.938,0,0,1-1.223,1.223,3.328,3.328,0,0,1-3.353,0,3.925,3.925,0,0,1-1.223-1.223,5.792,5.792,0,0,1-.725-1.631A7.9,7.9,0,0,1,14.2,24.1a7.911,7.911,0,0,1,.227-1.722,5.789,5.789,0,0,1,.725-1.631,3.938,3.938,0,0,1,1.223-1.223,3.327,3.327,0,0,1,3.353,0,3.958,3.958,0,0,1,1.223,1.223,5.809,5.809,0,0,1,.725,1.631A7.933,7.933,0,0,1,21.9,24.1ZM15.738,27.18H20.36V26.047H18.82V20.609H17.46l-1.813,1.676.952.952a7.42,7.42,0,0,0,.634-.68h.045v3.489H15.738V27.18Z"
              transform="translate(-724.416 2225.541)"
              fill="#dc1212"
            />
          </g>
        </svg>
      ) : svgName === flowChartElement.purchaseOrder ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20.556"
          height="22.296"
          viewBox="0 0 20.556 22.296"
        >
          <g
            id="Group_15110"
            data-name="Group 15110"
            transform="translate(-3779.849 -1050.124)"
          >
            <path
              id="Path_2469"
              data-name="Path 2469"
              d="M374.837,218.063H383.8l2.512,1,.412,9.642h-4.7l-.48,10.276H368.592l-1.042-1.042V221.007l.51-1.94,2.676-1,1.736.491.491-.491Z"
              transform="translate(3413.003 832.749)"
              fill="#eb00ac"
              opacity="0.12"
            />
            <g id="order" transform="translate(3779.849 1050.124)">
              <path
                id="Path_2461"
                data-name="Path 2461"
                d="M34.939-496.87a3.254,3.254,0,0,0-.674.246,3.2,3.2,0,0,0-1.682,2.049c-.079.288-.084.739-.084,9.872,0,9.486,0,9.57.093,9.728a.794.794,0,0,0,.256.242c.153.084.427.088,7.363.088,6.764,0,7.21,0,7.363-.084a.758.758,0,0,0,.265-.237l.107-.158v-9.737l2.313-.014c2.211-.014,2.313-.019,2.467-.107a.8.8,0,0,0,.242-.256c.084-.153.088-.358.088-4.474,0-4.878.009-4.7-.358-5.463a2.335,2.335,0,0,0-.59-.818,2.49,2.49,0,0,0-.818-.6c-.767-.376-.177-.353-8.571-.348C36.5-496.94,35.19-496.926,34.939-496.87Zm12.311,1.245c0,.009-.074.139-.163.288a3.968,3.968,0,0,0-.293.646l-.125.372-.014,9.184-.009,9.189H33.824l.009-9.189.014-9.184.135-.279a1.967,1.967,0,0,1,1.222-.994C35.371-495.63,47.249-495.662,47.249-495.625Zm3.368.158a2.071,2.071,0,0,1,.873.79c.269.492.265.427.265,4.618v3.846H47.946v-3.846c0-4.19,0-4.125.265-4.618a2.1,2.1,0,0,1,1.208-.92A2.105,2.105,0,0,1,50.617-495.467Z"
                transform="translate(-32.5 496.942)"
                fill="#a20067"
              />
              <path
                id="Path_2462"
                data-name="Path 2462"
                d="M125.658-435.877a4.951,4.951,0,0,0-.567.5l-.427.423-.2-.144a3.284,3.284,0,0,0-1.965-.618,3.122,3.122,0,0,0-2.323.952,3.108,3.108,0,0,0-.985,2.207,3.164,3.164,0,0,0,.367,1.691,3.577,3.577,0,0,0,1.431,1.412,4.454,4.454,0,0,0,.7.274,4.164,4.164,0,0,0,1.626,0,3.33,3.33,0,0,0,2.16-1.775,3.238,3.238,0,0,0,.167-2.527l-.149-.437.534-.539c.423-.432.539-.571.562-.711A.652.652,0,0,0,125.658-435.877Zm-2.276,1.663.362.177-.59.585-.585.59-.218-.218c-.274-.26-.376-.316-.595-.316a.618.618,0,0,0-.627.655c0,.265.111.427.655.952.418.4.511.469.692.483.353.033.353.028,1.185-.794.887-.873.859-.864.859-.321a2.028,2.028,0,0,1-2.332,2,2.016,2.016,0,0,1-1.171-3.349,1.866,1.866,0,0,1,1.556-.632A1.4,1.4,0,0,1,123.381-434.214Z"
                transform="translate(-115.159 438.782)"
                fill="#a20067"
              />
              <path
                id="Path_2463"
                data-name="Path 2463"
                d="M89.372-232.787a.685.685,0,0,0-.372.576.617.617,0,0,0,.669.641.42.42,0,0,0,.4-.177.565.565,0,0,0,.144-.725.481.481,0,0,0-.293-.307A.5.5,0,0,0,89.372-232.787Z"
                transform="translate(-86.375 245.132)"
                fill="#a20067"
              />
              <path
                id="Path_2464"
                data-name="Path 2464"
                d="M145.446-232.686a.683.683,0,0,0-.446.632.691.691,0,0,0,.3.53c.149.093.223.093,3.507.093,3.744,0,3.517.019,3.712-.325a.626.626,0,0,0-.186-.841l-.158-.111-3.3-.009C147.067-232.723,145.52-232.709,145.446-232.686Z"
                transform="translate(-139.774 244.994)"
                fill="#a20067"
              />
              <path
                id="Path_2465"
                data-name="Path 2465"
                d="M89.289-175.907a.639.639,0,0,0,.325,1.175.6.6,0,0,0,.6-.372.567.567,0,0,0-.149-.72.42.42,0,0,0-.4-.177A.716.716,0,0,0,89.289-175.907Z"
                transform="translate(-86.372 190.909)"
                fill="#a20067"
              />
              <path
                id="Path_2466"
                data-name="Path 2466"
                d="M145.3-175.912a.723.723,0,0,0-.3.534.712.712,0,0,0,.283.544l.158.111h3.345c3.112,0,3.354,0,3.493-.084a.652.652,0,0,0,.042-1.106c-.139-.084-.3-.088-3.512-.088S145.437-176,145.3-175.912Z"
                transform="translate(-139.774 190.909)"
                fill="#a20067"
              />
              <path
                id="Path_2467"
                data-name="Path 2467"
                d="M89.308-119.869a.654.654,0,0,0,.181,1.171.642.642,0,0,0,.748-.892A.668.668,0,0,0,89.308-119.869Z"
                transform="translate(-86.39 137.473)"
                fill="#a20067"
              />
              <path
                id="Path_2468"
                data-name="Path 2468"
                d="M145.586-119.691a.663.663,0,0,0-.293.934c.228.339.051.325,3.7.325,3.54,0,3.466,0,3.67-.256a.716.716,0,0,0,.13-.557.933.933,0,0,0-.19-.293l-.153-.172-3.387-.009C147.2-119.723,145.637-119.709,145.586-119.691Z"
                transform="translate(-139.965 137.243)"
                fill="#a20067"
              />
            </g>
          </g>
        </svg>
      ) : svgName === flowChartElement.purchaseWpo ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18.206"
          height="19.746"
          viewBox="0 0 18.206 19.746"
        >
          <g
            id="Group_15133"
            data-name="Group 15133"
            transform="translate(712 -1904.324)"
          >
            <path
              id="Path_2531"
              data-name="Path 2531"
              d="M374,218.063h7.941l2.225.889.365,8.539h-4.163l-.425,9.1H368.473l-.923-.923v-15l.452-1.719,2.37-.889,1.537.435.435-.435Z"
              transform="translate(-1078.927 1686.871)"
              fill="#57a200"
              opacity="0.12"
            />
            <g id="order" transform="translate(-712 1904.325)">
              <path
                id="Path_2461"
                data-name="Path 2461"
                d="M34.66-496.878a2.884,2.884,0,0,0-.6.218,2.831,2.831,0,0,0-1.489,1.814c-.07.255-.074.654-.074,8.743,0,8.4,0,8.475.082,8.615a.7.7,0,0,0,.226.214c.136.074.379.078,6.521.078,5.99,0,6.385,0,6.521-.074a.672.672,0,0,0,.235-.21l.095-.14v-8.624l2.049-.012c1.958-.012,2.049-.016,2.185-.095a.7.7,0,0,0,.214-.226c.074-.136.078-.317.078-3.962,0-4.32.008-4.164-.317-4.838a2.068,2.068,0,0,0-.523-.724,2.2,2.2,0,0,0-.724-.531c-.679-.333-.156-.313-7.591-.309C36.047-496.94,34.882-496.928,34.66-496.878Zm10.9,1.1c0,.008-.066.123-.144.255a3.516,3.516,0,0,0-.259.572l-.111.329-.012,8.134-.008,8.138H33.673l.008-8.138.012-8.134.119-.247a1.742,1.742,0,0,1,1.082-.88C35.043-495.78,45.563-495.809,45.563-495.776Zm2.983.14a1.834,1.834,0,0,1,.773.7c.239.436.235.378.235,4.09v3.407H46.18v-3.407c0-3.711,0-3.654.235-4.09a1.861,1.861,0,0,1,1.07-.815A1.864,1.864,0,0,1,48.546-495.636Z"
                transform="translate(-32.5 496.942)"
                fill="#57a200"
              />
              <path
                id="Path_2462"
                data-name="Path 2462"
                d="M124.918-435.885a4.387,4.387,0,0,0-.5.44l-.379.374-.177-.128a2.908,2.908,0,0,0-1.74-.547,2.765,2.765,0,0,0-2.057.843,2.753,2.753,0,0,0-.872,1.954,2.8,2.8,0,0,0,.325,1.5,3.168,3.168,0,0,0,1.267,1.251,3.949,3.949,0,0,0,.617.243,3.689,3.689,0,0,0,1.44,0,2.949,2.949,0,0,0,1.913-1.572,2.868,2.868,0,0,0,.148-2.238l-.132-.387.473-.477c.374-.383.477-.506.5-.629A.577.577,0,0,0,124.918-435.885Zm-2.016,1.473.321.156-.523.518-.518.523-.193-.193c-.243-.23-.333-.28-.527-.28a.547.547,0,0,0-.555.58c0,.235.1.379.58.843.37.358.453.416.613.428.313.029.313.025,1.049-.7.786-.774.761-.765.761-.284a1.8,1.8,0,0,1-2.065,1.769,1.786,1.786,0,0,1-1.037-2.966,1.653,1.653,0,0,1,1.378-.56A1.243,1.243,0,0,1,122.9-434.412Z"
                transform="translate(-115.619 438.458)"
                fill="#57a200"
              />
              <path
                id="Path_2463"
                data-name="Path 2463"
                d="M89.329-232.8a.607.607,0,0,0-.329.51.547.547,0,0,0,.592.568.372.372,0,0,0,.354-.156.5.5,0,0,0,.128-.642.426.426,0,0,0-.259-.272A.443.443,0,0,0,89.329-232.8Z"
                transform="translate(-86.675 243.729)"
                fill="#57a200"
              />
              <path
                id="Path_2464"
                data-name="Path 2464"
                d="M145.395-232.69a.6.6,0,0,0-.395.56.612.612,0,0,0,.267.469c.132.082.2.082,3.106.082,3.316,0,3.115.016,3.287-.288a.555.555,0,0,0-.165-.745l-.14-.1-2.921-.008C146.831-232.723,145.461-232.71,145.395-232.69Z"
                transform="translate(-140.371 243.59)"
                fill="#57a200"
              />
              <path
                id="Path_2465"
                data-name="Path 2465"
                d="M89.256-175.918a.566.566,0,0,0,.288,1.041.53.53,0,0,0,.531-.329.5.5,0,0,0-.132-.638.372.372,0,0,0-.354-.156A.635.635,0,0,0,89.256-175.918Z"
                transform="translate(-86.672 189.205)"
                fill="#57a200"
              />
              <path
                id="Path_2466"
                data-name="Path 2466"
                d="M145.263-175.922a.64.64,0,0,0-.263.473.631.631,0,0,0,.251.481l.14.1h2.962c2.757,0,2.971,0,3.094-.074a.578.578,0,0,0,.037-.979c-.123-.074-.263-.078-3.11-.078S145.387-176,145.263-175.922Z"
                transform="translate(-140.371 189.205)"
                fill="#57a200"
              />
              <path
                id="Path_2467"
                data-name="Path 2467"
                d="M89.274-119.88a.579.579,0,0,0,.16,1.037.569.569,0,0,0,.662-.79A.592.592,0,0,0,89.274-119.88Z"
                transform="translate(-86.69 135.471)"
                fill="#57a200"
              />
              <path
                id="Path_2468"
                data-name="Path 2468"
                d="M145.542-119.694a.587.587,0,0,0-.259.827c.2.3.045.288,3.275.288,3.135,0,3.069,0,3.25-.226a.634.634,0,0,0,.115-.494.826.826,0,0,0-.169-.259l-.136-.152-3-.008C146.974-119.723,145.587-119.71,145.542-119.694Z"
                transform="translate(-140.564 135.239)"
                fill="#57a200"
              />
            </g>
          </g>
        </svg>
      ) : svgName === flowChartElement.quotation ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17.569"
          height="22.332"
          viewBox="0 0 17.569 22.332"
        >
          <g
            id="Group_15157"
            data-name="Group 15157"
            transform="translate(-366.852 -217.334)"
          >
            <path
              id="Path_2459"
              data-name="Path 2459"
              d="M374.776,218.063h4.114v1.725h4.29l.487,1.814v15.968l-1.239,1.239H368.584l-1.033-1.033V220.982l1.427-1.427h3.455v-1.006l.487-.487Z"
              fill="#a14000"
              opacity="0.12"
            />
            <g
              id="Group_14874"
              data-name="Group 14874"
              transform="translate(1388.001 -256.109)"
            >
              <path
                id="Path_872"
                data-name="Path 872"
                d="M85.8-479.688a1.621,1.621,0,0,0-1.2,1.317l-.035.234H83.233a7.917,7.917,0,0,0-1.626.075,2.441,2.441,0,0,0-1.746,1.756c-.115.429-.115,16.659,0,17.088a2.441,2.441,0,0,0,1.746,1.756c.259.065,1.132.075,6.913.075,4.29,0,6.709-.02,6.883-.05a2.464,2.464,0,0,0,1.89-1.89c.03-.17.05-3.227.05-8.479,0-9.043.02-8.479-.3-9.088a2.712,2.712,0,0,0-.983-.963c-.494-.249-.718-.279-2.16-.279H92.565l-.035-.234a1.938,1.938,0,0,0-.394-.848,1.959,1.959,0,0,0-.439-.319l-.314-.17-2.718-.01C87.168-479.723,85.881-479.708,85.8-479.688Zm5.162,4.883v3.327l-1.077-.534a3.96,3.96,0,0,0-1.3-.539,4,4,0,0,0-1.317.549l-1.1.549v-6.684h4.788Zm-6.374.993.015,2.733.12.259a1.932,1.932,0,0,0,.843.828,1.4,1.4,0,0,0,.614.1l.384.005,1-.5,1-.494,1,.494,1,.5.384-.005a1.4,1.4,0,0,0,.633-.115,1.872,1.872,0,0,0,.828-.828c.115-.249.115-.249.13-2.983l.015-2.733,1.342.015c1.262.015,1.347.02,1.476.12a1.362,1.362,0,0,1,.239.239l.1.135v16.55l-.1.135a1.358,1.358,0,0,1-.239.239c-.135.1-.15.1-6.813.1s-6.679,0-6.813-.1a1.358,1.358,0,0,1-.239-.239c-.1-.135-.1-.145-.12-8.275,0-4.479,0-8.21.015-8.3a.863.863,0,0,1,.449-.544,6.46,6.46,0,0,1,1.432-.07H84.57Z"
                transform="translate(-1100.924 953.162)"
                fill="#a14000"
              />
              <g
                id="Group_14872"
                data-name="Group 14872"
                transform="translate(0.006 -3)"
              >
                <path
                  id="Path_873"
                  data-name="Path 873"
                  d="M176.58-207.71a.82.82,0,0,0-.454.9.854.854,0,0,0,.519.574c.125.04,1.282.05,3.561.04,3.317-.015,3.377-.015,3.511-.12a.7.7,0,0,0,.344-.668.7.7,0,0,0-.344-.668c-.135-.1-.19-.1-3.561-.115A27.946,27.946,0,0,0,176.58-207.71Z"
                  transform="translate(-1192.457 694.776)"
                  fill="#a14000"
                />
                <path
                  id="Path_874"
                  data-name="Path 874"
                  d="M176.58-143.71a.82.82,0,0,0-.454.9.854.854,0,0,0,.519.574c.125.04,1.042.05,2.763.04,2.514-.015,2.579-.02,2.713-.12a.7.7,0,0,0,.344-.668.7.7,0,0,0-.344-.668c-.135-.1-.2-.1-2.763-.115A17.632,17.632,0,0,0,176.58-143.71Z"
                  transform="translate(-1192.457 633.968)"
                  fill="#a14000"
                />
              </g>
              <g
                id="Group_14891"
                data-name="Group 14891"
                transform="translate(0.006 3.997)"
              >
                <path
                  id="Path_873-2"
                  data-name="Path 873"
                  d="M176.58-207.71a.82.82,0,0,0-.454.9.854.854,0,0,0,.519.574c.125.04,1.282.05,3.561.04,3.317-.015,3.377-.015,3.511-.12a.7.7,0,0,0,.344-.668.7.7,0,0,0-.344-.668c-.135-.1-.19-.1-3.561-.115A27.946,27.946,0,0,0,176.58-207.71Z"
                  transform="translate(-1192.457 694.776)"
                  fill="#a14000"
                />
                <path
                  id="Path_874-2"
                  data-name="Path 874"
                  d="M176.58-143.71a.82.82,0,0,0-.454.9.854.854,0,0,0,.519.574c.125.04,1.042.05,2.763.04,2.514-.015,2.579-.02,2.713-.12a.7.7,0,0,0,.344-.668.7.7,0,0,0-.344-.668c-.135-.1-.2-.1-2.763-.115A17.632,17.632,0,0,0,176.58-143.71Z"
                  transform="translate(-1192.457 633.968)"
                  fill="#a14000"
                />
              </g>
            </g>
          </g>
        </svg>
      ) : svgName === flowChartElement.receipt? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21.367"
          height="23.292"
          viewBox="0 0 21.367 23.292"
        >
          <g
            id="Group_15184"
            data-name="Group 15184"
            transform="translate(152.68 -2518.354)"
          >
            <path
              id="Path_2480"
              data-name="Path 2480"
              d="M120.926-374.932a.773.773,0,0,0,0,1.391c.209.1.243.1,3.521.088s3.312-.015,3.448-.117a1.434,1.434,0,0,0,.248-.263.782.782,0,0,0-.282-1.065c-.18-.1-.209-.1-3.482-.1A28.328,28.328,0,0,0,120.926-374.932Z"
              transform="translate(-269.065 2899.235)"
              fill="#dc1412"
            />
            <path
              id="Path_2481"
              data-name="Path 2481"
              d="M120.912-289.671a.871.871,0,0,0-.55.618.859.859,0,0,0,.36.768l.165.112h6.721l.175-.117a.776.776,0,0,0-.053-1.313c-.165-.1-.238-.1-3.4-.112C122.293-289.719,121.024-289.7,120.912-289.671Z"
              transform="translate(-268.939 2818.098)"
              fill="#dc1412"
            />
            <g id="Group_15183" data-name="Group 15183">
              <path
                id="Path_2469"
                data-name="Path 2469"
                d="M370.821,219.059h1.228l2.235-.2h2.356l3.188,1.047.46,6.08-4.025.69-.46,13.513s.128-1.351-3.753-1.265c-1.129.025-2.014,1.374-3.837,1.61-1.184.153-2.546-1.6-4.083-1.61a6.983,6.983,0,0,0-3.853,1.61V221.959l.863-2.3,6.279-.7,1.53.1h1.872Z"
                transform="translate(-512.236 2299.973)"
                fill="#dc1412"
                opacity="0.12"
              />
              <path
                id="Path_2479"
                data-name="Path 2479"
                d="M38.428-495.839a3.072,3.072,0,0,0-2.247,2.383c-.034.224-.049,3.142-.039,10.091l.015,9.775.1.195a1.107,1.107,0,0,0,1.221.545,17.7,17.7,0,0,0,1.751-.973c.832-.5,1.537-.909,1.571-.909s.841.472,1.809,1.046c1.751,1.046,1.756,1.046,2.043,1.046a1.5,1.5,0,0,0,.457-.073c.092-.039.9-.511,1.8-1.05a12.107,12.107,0,0,1,1.722-.953c.053.015.773.438,1.61.939,1.44.871,1.527.914,1.8.934a1.019,1.019,0,0,0,.914-.36,1.3,1.3,0,0,0,.243-.433c.039-.151.053-2.111.053-6.8v-6.59l1.449-.015,1.444-.015.277-.131a2,2,0,0,0,.929-.909l.156-.321v-5.058l-.117-.36a3.085,3.085,0,0,0-2.174-2c-.365-.1-.569-.1-8.4-.092C39.07-495.932,38.768-495.927,38.428-495.839ZM51.962-494.3c-.024.049-.088.209-.141.355-.1.267-.1.267-.126,9.731l-.024,9.469-1.162-.7a14.861,14.861,0,0,0-1.386-.764,2.415,2.415,0,0,0-1.055,0c-.112.034-.919.486-1.79,1.007l-1.581.948-1.425-.856c-.783-.472-1.488-.895-1.571-.943a2.148,2.148,0,0,0-.88-.243c-.472,0-.676.088-1.906.827l-1.2.725-.015-9.2c0-5.88,0-9.26.039-9.371a1.478,1.478,0,0,1,.939-.982c.238-.083.642-.088,6.789-.092C51.665-494.38,52-494.375,51.962-494.3Zm3.2.083a1.458,1.458,0,0,1,.671.676c.112.2.112.224.126,2.485.015,2.086,0,2.286-.068,2.368s-.175.092-1.367.092H53.251v-2.4c0-2.3,0-2.4.1-2.612a1.351,1.351,0,0,1,.822-.734A1.689,1.689,0,0,1,55.167-494.215Z"
                transform="translate(-188.819 3014.287)"
                fill="#dc1412"
              />
              <path
                id="Path_2482"
                data-name="Path 2482"
                d="M120.991-201.917a.772.772,0,0,0,.126,1.425c.122.039,1.221.049,3.448.039,3.224-.015,3.268-.015,3.4-.117a.77.77,0,0,0-.029-1.318l-.165-.112h-3.312A18.189,18.189,0,0,0,120.991-201.917Z"
                transform="translate(-269.145 2734.649)"
                fill="#dc1412"
              />
            </g>
          </g>
        </svg>
      ) : svgName === flowChartElement.rfq ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="Group_14875"
          data-name="Group 14875"
          width="17.05"
          height="21.672"
          viewBox="0 0 17.05 21.672"
        >
          <path
            id="Path_2459"
            data-name="Path 2459"
            d="M374.563,218.063h3.992v1.674h4.164l.472,1.76v15.5l-1.2,1.2H368.553l-1-1V220.9l1.384-1.384h3.353v-.976l.472-.472Z"
            transform="translate(-366.872 -217.356)"
            fill="#0800eb"
            opacity="0.12"
          />
          <g
            id="Group_14874"
            data-name="Group 14874"
            transform="translate(0 0)"
          >
            <path
              id="Path_872"
              data-name="Path 872"
              d="M85.619-479.689a1.573,1.573,0,0,0-1.162,1.278l-.034.228H83.131a7.687,7.687,0,0,0-1.578.073,2.369,2.369,0,0,0-1.694,1.7c-.111.416-.111,16.167,0,16.583a2.368,2.368,0,0,0,1.694,1.7c.252.063,1.1.073,6.709.073,4.163,0,6.51-.019,6.68-.048a2.391,2.391,0,0,0,1.835-1.834c.029-.165.048-3.132.048-8.229,0-8.776.019-8.229-.3-8.819a2.632,2.632,0,0,0-.954-.934c-.479-.242-.7-.271-2.1-.271H92.187l-.034-.228a1.881,1.881,0,0,0-.382-.823,1.9,1.9,0,0,0-.426-.31l-.3-.165-2.638-.01C86.95-479.723,85.7-479.709,85.619-479.689Zm5.01,4.739v3.229l-1.046-.518a3.843,3.843,0,0,0-1.259-.523,3.882,3.882,0,0,0-1.278.532l-1.065.532v-6.486h4.647Zm-6.186.963.015,2.653.116.252a1.876,1.876,0,0,0,.818.8,1.358,1.358,0,0,0,.6.1l.373,0,.973-.484.973-.479.973.479.973.484.373,0a1.357,1.357,0,0,0,.615-.111,1.816,1.816,0,0,0,.8-.8c.111-.242.111-.242.126-2.895l.015-2.653,1.3.014c1.225.015,1.307.019,1.433.116a1.322,1.322,0,0,1,.232.232l.1.131v16.061l-.1.131a1.317,1.317,0,0,1-.232.232c-.131.1-.145.1-6.612.1s-6.481,0-6.612-.1a1.317,1.317,0,0,1-.232-.232c-.1-.131-.1-.14-.116-8.03,0-4.347,0-7.967.015-8.055a.838.838,0,0,1,.436-.528,6.272,6.272,0,0,1,1.389-.068h1.244Z"
              transform="translate(-79.775 479.719)"
              fill="#0800eb"
            />
            <g
              id="Group_14872"
              data-name="Group 14872"
              transform="translate(4.661 13.163)"
            >
              <path
                id="Path_873"
                data-name="Path 873"
                d="M176.566-207.712a.8.8,0,0,0-.441.876.829.829,0,0,0,.5.557c.121.039,1.244.048,3.456.039,3.219-.015,3.277-.015,3.408-.116a.683.683,0,0,0,.334-.649.683.683,0,0,0-.334-.649c-.131-.1-.184-.1-3.456-.111A27.116,27.116,0,0,0,176.566-207.712Z"
                transform="translate(-176.111 207.769)"
                fill="#0800eb"
              />
              <path
                id="Path_874"
                data-name="Path 874"
                d="M176.566-143.712a.8.8,0,0,0-.441.876.828.828,0,0,0,.5.557c.121.039,1.012.048,2.682.039,2.44-.014,2.5-.019,2.633-.116a.683.683,0,0,0,.334-.649.683.683,0,0,0-.334-.649c-.131-.1-.194-.1-2.682-.111A17.106,17.106,0,0,0,176.566-143.712Z"
                transform="translate(-176.111 146.867)"
                fill="#0800eb"
              />
            </g>
          </g>
        </svg>
      ) : svgName === flowChartElement.salesOrder ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22.025"
          height="22.109"
          viewBox="0 0 22.025 22.109"
        >
          <g
            id="Group_15180"
            data-name="Group 15180"
            transform="translate(-335.302 -2302.691)"
          >
            <path
              id="Path_2469"
              data-name="Path 2469"
              d="M374.776,218.063h4.114l1.3,1,3.7,3.35v7.5l-.625,8.9H368.584l-3.437-.871-2.276-3.124.357-3.079s.035.858,1.116-1.83c.316-.785.821.45,1.339-.982a1.915,1.915,0,0,0,2.142-.937c.822-1.869.232-6.917.232-6.917v-2.011l2.654-1,1.721.487.487-.487Z"
              transform="translate(-26.908 2085.31)"
              fill="#7dbb00"
              opacity="0.12"
            />
            <g id="file" transform="translate(334.167 2814.617)">
              <path
                id="Path_2486"
                data-name="Path 2486"
                d="M7.8-511.869a1.841,1.841,0,0,0-.911.523,1.845,1.845,0,0,0-.531.963c-.035.16-.048,1.547-.048,4.579v4.354l-.415.078a5.624,5.624,0,0,0-3.063,1.642,5.358,5.358,0,0,0-1.4,2.251,5.823,5.823,0,0,0,.708,5.119,6.729,6.729,0,0,0,.691.8,5.737,5.737,0,0,0,2.937,1.629l.389.091,7.581.017c5.555.009,7.65,0,7.84-.035a2.18,2.18,0,0,0,1.032-.562,2.16,2.16,0,0,0,.5-.942c.035-.164.048-2.4.048-7.983,0-7.015-.009-7.767-.069-7.892-.1-.19-4.406-4.51-4.6-4.614-.156-.078-.3-.082-5.313-.078C9.2-511.921,7.972-511.908,7.8-511.869Zm9.741,3.136c0,1.823,0,1.909.086,2.073a.579.579,0,0,0,.259.259c.164.082.251.086,2.074.086h1.9v7.344c0,7.279,0,7.348-.086,7.516a.579.579,0,0,1-.259.259c-.168.086-.242.086-5.516.086H10.655l.436-.445a5.723,5.723,0,0,0,1.6-3.028l.078-.415h3.426c3.352,0,3.434,0,3.6-.086a.682.682,0,0,0,.346-.562.682.682,0,0,0-.346-.562c-.164-.086-.246-.086-3.6-.086H12.758l-.026-.207a6.408,6.408,0,0,0-.7-2,3.752,3.752,0,0,1-.19-.359c0-.013,1.75-.022,3.888-.022,3.814,0,3.9,0,4.061-.086a.682.682,0,0,0,.346-.562.682.682,0,0,0-.346-.562c-.168-.086-.246-.086-4.665-.086h-4.5l-.225-.164a6,6,0,0,0-2.588-1.071l-.207-.026v-4.35c0-4.886-.022-4.527.328-4.739l.168-.1h9.439Zm2.354.086,1.037,1.037h-2.1v-1.037c0-.57,0-1.037.013-1.037S19.329-509.217,19.9-508.647ZM8-500.059a4.707,4.707,0,0,1,2.164,1.214,4.715,4.715,0,0,1,1.218,2.164,3.608,3.608,0,0,1,.086,1.037,3.646,3.646,0,0,1-.311,1.706,4.705,4.705,0,0,1-2.488,2.488,3.646,3.646,0,0,1-1.706.311,3.646,3.646,0,0,1-1.706-.311,4.705,4.705,0,0,1-2.488-2.488,3.711,3.711,0,0,1-.315-1.685,3.822,3.822,0,0,1,.341-1.8,4.668,4.668,0,0,1,3.5-2.717A6.233,6.233,0,0,1,8-500.059Z"
                transform="translate(0 0)"
                fill="#7dbb00"
              />
              <path
                id="Path_2487"
                data-name="Path 2487"
                d="M191.337-329.909a.692.692,0,0,0-.337.557.682.682,0,0,0,.346.562c.168.086.242.086,5.054.086s4.886,0,5.054-.086a.682.682,0,0,0,.346-.562.682.682,0,0,0-.346-.562c-.168-.086-.242-.086-5.063-.086C191.6-330,191.492-330,191.337-329.909Z"
                transform="translate(-181.663 -174.068)"
                fill="#7dbb00"
              />
              <path
                id="Path_2488"
                data-name="Path 2488"
                d="M121.337-209.694a.619.619,0,0,0-.251.255c-.082.16-.086.251-.086,1.6s0,1.439.086,1.6a.579.579,0,0,0,.259.259c.156.078.251.086,1.166.086s1.011-.009,1.166-.086a.682.682,0,0,0,.346-.562.682.682,0,0,0-.346-.562c-.147-.073-.255-.086-.778-.086h-.6v-1.037c0-.959-.009-1.054-.086-1.21A.632.632,0,0,0,121.337-209.694Z"
                transform="translate(-114.687 -289.099)"
                fill="#7dbb00"
              />
            </g>
          </g>
        </svg>
      ) : svgName === flowChartElement.swso ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20.776"
          height="22.99"
          viewBox="0 0 20.776 22.99"
        >
          <g
            id="Group_15159"
            data-name="Group 15159"
            transform="translate(-366.852 -216.559)"
          >
            <path
              id="Path_2469"
              data-name="Path 2469"
              d="M377.255,217.315l2.266-.206.755,1.236v2.06l-.618.927-.721-.446-.137-1.064-3.364,3.158-1.785-.584-5.836,5.218-.721-.893,2.2-2.4,3.673-3.6,1.991.618,1-.79,1.751-1.716-1.407-.343v-.927Z"
              transform="translate(-0.014 -0.381)"
              fill="#004343"
              opacity="0.12"
            />
            <path
              id="Path_2496"
              data-name="Path 2496"
              d="M383.446,224.452l-4.646,3.908-8.9,2.3-2.086-5.836,1.347-1.558.132-3.063,1.9-.381,1.109,2.467,2.139-.607.792,1.135-1.611,2.245-.264.449H376.4l3.565-1.373,2.324-1.452Z"
              transform="translate(3.986 5.619)"
              fill="#004343"
              opacity="0.12"
            />
            <g id="order" transform="translate(334.352 713.942)">
              <g id="sales" transform="translate(7.306 14.617)">
                <path
                  id="Path_2493"
                  data-name="Path 2493"
                  d="M34.727-511.892a.9.9,0,0,0-.512.521,1.114,1.114,0,0,0,.144,1.114,1.138,1.138,0,0,0,.674.31l.229.027-1.006.979-1.01.974-.629-.328c-.727-.377-.9-.422-1.266-.314-.26.076-.278.094-3.089,2.928-1.554,1.567-2.874,2.928-2.932,3.022a1.206,1.206,0,0,0-.13.413,1.072,1.072,0,0,0,.647,1.055,1.164,1.164,0,0,0,.781-.009c.085-.04,1.3-1.217,2.694-2.613l2.541-2.537.642.328c.588.305.665.332.916.332a1.031,1.031,0,0,0,.454-.09c.1-.049.781-.674,1.549-1.41,1.01-.974,1.374-1.3,1.383-1.235.112.84.413,1.194,1.01,1.2a1.017,1.017,0,0,0,.979-.62c.076-.162.085-.328.085-1.778v-1.594l-.121-.247a.854.854,0,0,0-.346-.377l-.22-.135-1.621-.013L34.952-512Zm3.408.678a5.385,5.385,0,0,1,.072,1.581v1.491l-.1.121a.3.3,0,0,1-.256.121.3.3,0,0,1-.256-.121c-.1-.117-.1-.157-.1-.763,0-.566-.009-.66-.085-.75a.284.284,0,0,0-.247-.1c-.139,0-.207.04-.467.3-1.805,1.756-3.089,2.959-3.193,2.986s-.265-.049-.867-.359a5.15,5.15,0,0,0-.867-.391,24.727,24.727,0,0,0-2.748,2.649c-2.456,2.474-2.64,2.649-2.784,2.649a.347.347,0,0,1-.314-.525c.031-.054,1.3-1.352,2.833-2.883,1.805-1.814,2.806-2.788,2.865-2.788a6.039,6.039,0,0,1,.84.382,4.819,4.819,0,0,0,.876.382c.126,0,.382-.238,2.577-2.362.548-.53.561-.548.534-.7-.054-.278-.144-.31-.826-.31-.579,0-.606,0-.709-.112a.339.339,0,0,1-.054-.431c.13-.166.2-.175,1.724-.162C38.01-511.3,38.073-511.3,38.136-511.214Z"
                  transform="translate(0)"
                  fill="#004343"
                />
                <path
                  id="Path_2494"
                  data-name="Path 2494"
                  d="M43.526-455.889a1.58,1.58,0,0,0-.943.858l-.126.269-.013,5.281-.013,5.281-.251.054c-.139.027-.269.049-.287.049s-.045-1.661-.049-3.7l-.013-3.691-.1-.252a1.517,1.517,0,0,0-.763-.813c-.3-.148-.305-.148-.952-.148-.615,0-.665.009-.912.121a1.707,1.707,0,0,0-.8.831c-.1.256-.1.305-.121,2.133l-.018,1.868-.26.139a2.626,2.626,0,0,1-.283.139c-.009,0-.027-.319-.04-.709-.018-.642-.027-.727-.135-.952a1.433,1.433,0,0,0-.66-.683c-.193-.094-.265-.1-1.037-.1-.813,0-.835,0-1.055.121a1.324,1.324,0,0,0-.624.665l-.117.247v3.368l-.557.3a8.2,8.2,0,0,1-2.1.732c-1.792.507-2.16.66-2.506,1.042a2.436,2.436,0,0,0-.539,1.042,3.518,3.518,0,0,0,.2,1.621c.207.777.274.9.507.9.121,0,.328-.184.328-.292,0-.04-.094-.431-.207-.867a2.981,2.981,0,0,1-.18-1.064,1.432,1.432,0,0,1,.674-1.122c.162-.094,3.161-1,3.188-.956.009.009.5,1.325,1.1,2.928l1.087,2.919-.018.3a1.541,1.541,0,0,1-.835,1.262,15.6,15.6,0,0,1-2.658.6,1.3,1.3,0,0,1-1-.4c-.242-.251-.314-.427-.57-1.432-.189-.732-.251-.916-.341-1a.317.317,0,0,0-.53.139,12.906,12.906,0,0,0,.6,2.259,2.247,2.247,0,0,0,.844.885,2.557,2.557,0,0,0,.983.256,15.641,15.641,0,0,0,3.067-.709,2.3,2.3,0,0,0,.934-.952,1.908,1.908,0,0,0,.2-1,1.117,1.117,0,0,1,.022-.346c.076,0,7.409-1.814,7.647-1.89a4.357,4.357,0,0,0,1.1-.552c.148-.1,1.118-.889,2.155-1.742,2-1.652,2.128-1.778,2.25-2.245a1.309,1.309,0,0,0-.027-.849,1.683,1.683,0,0,0-.516-.795,1.572,1.572,0,0,0-1.787-.171c-.189.09-.35.162-.364.162s-.027-1.271-.027-2.824v-2.829l-.117-.09a.269.269,0,0,0-.409.013l-.126.108-.013,3.08-.013,3.08-.436.328a10.477,10.477,0,0,1-1.828,1.2c-.013,0-.018-2.29-.013-5.087.013-4.629.018-5.1.09-5.218.2-.359.458-.471,1.078-.471.548,0,.763.076.961.341.13.166.13.18.157.907.022.705.027.745.126.822a.371.371,0,0,0,.445.013c.094-.067.1-.094.1-.8a2.557,2.557,0,0,0-.09-.979,1.552,1.552,0,0,0-.983-.912A4.5,4.5,0,0,0,43.526-455.889Zm-2.748,4a1.091,1.091,0,0,1,.283.314c.094.175.094.229.108,3.826l.013,3.651H40.055a9.305,9.305,0,0,1-1.123-.036,2.6,2.6,0,0,1,.409-.368,6.007,6.007,0,0,0,.629-.579,3.85,3.85,0,0,0,.691-1.352,1.366,1.366,0,0,0-.736-1.675,1.7,1.7,0,0,0-.912-.063l-.126.031v-1.639c0-1.549,0-1.652.09-1.819a.874.874,0,0,1,.485-.409,3.883,3.883,0,0,1,.624-.027C40.563-452.023,40.594-452.014,40.778-451.889Zm-4.225,2.726c.323.225.337.26.35,1.217l.013.862-1.118.593c-.62.328-1.136.6-1.15.6s-.027-.656-.027-1.455c0-1.432,0-1.45.1-1.6.175-.265.328-.31,1.046-.31C36.355-449.262,36.418-449.253,36.553-449.163Zm3.1,1.679c.35.139.467.462.337.929a2.678,2.678,0,0,1-1.055,1.513c-.534.436-.629.561-.629.88a.728.728,0,0,0,.355.633c.153.1.162.1,1.778.1a7.017,7.017,0,0,0,2.07-.112,7.776,7.776,0,0,0,2.69-1.531c.79-.557,1.513-1.051,1.6-1.1a.959.959,0,0,1,1.154.278.908.908,0,0,1-.184,1.325c-.166.157-3.058,2.537-3.628,2.986a3.331,3.331,0,0,1-.921.512c-.386.148-7.8,1.958-7.844,1.917-.018-.018-.467-1.2-1-2.636s-.979-2.613-.988-2.627,1.046-.593,2.344-1.284a27.157,27.157,0,0,1,3.633-1.859A.984.984,0,0,1,39.651-447.484Z"
                  transform="translate(-2.881 -53.533)"
                  fill="#004343"
                />
                <path
                  id="Path_2495"
                  data-name="Path 2495"
                  d="M90.2-92.737a1.328,1.328,0,0,0-.678,2.191,1.245,1.245,0,0,0,.858.4,1.32,1.32,0,0,0,1.414-1.145,1.34,1.34,0,0,0-1.01-1.437A1,1,0,0,0,90.2-92.737Zm.557.714A.635.635,0,0,1,90.81-90.9a.692.692,0,0,1-.732-.054.619.619,0,0,1-.229-.566.569.569,0,0,1,.359-.512A.5.5,0,0,1,90.757-92.023Z"
                  transform="translate(-61.103 -400.399)"
                  fill="#004343"
                />
              </g>
            </g>
          </g>
        </svg>
      ) : (
        ""
      )}
    </>
  );
};

export default IconSvg;
